import { MysteryBetSchema } from '@/views/races/components/MysteryBet/styles/MysteryBet.styles';
import mysteryLogo from '@/assets/sugarcastle/images/mb-logo.png';

export const mysteryBetStyles: MysteryBetSchema = {
  flexWrapperOdds: {
    gap: 2,
    alignItems: 'center',
  },
  flexWrapperLogoOdds: {
    gap: 3,
  },
  buttonOdds: { variant: 'solid', px: '2' },
  imageLogo: {
    w: ['200px', '250px'],
    src: mysteryLogo,
    top: 1,
  },
  iconMystery: {},
  buttonMysteryLabel: {
    variant: 'unstyled',
    color: 'white',
    gap: '2',
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    p: '2',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 'sm',
    fontWeight: 'bold',
    boxShadow:
      '0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.10)',
  },
  flexWrapperMysteryRolloverView: {
    w: 'fit-content',
    bg: 'blackAlpha.400',
    boxShadow:
      '0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset, 0px 1px 0px 0px rgba(255, 255, 255, 0.10)',
    borderRadius: 'md',
    p: '1',
    px: '3',
    color: 'white',
    overflow: 'hidden',
    mx: 'auto',
    fontSize: 'xs',
  },
  flexWrapperMysteryPlacedBetView: {},
  flexWrapperMysteryBetSelectionView: {
    alignItems: 'center',
    justifyContent: 'center',
    gap: '2',
    mb: '2',
    bg: 'gamma.600',
    borderRadius: 'md',
    boxShadow: 'sm',
    p: '2',
    bgBlendMode: 'exclusion',
  },
  flexWrapperMysteryBetReviewView: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDir: 'column',
    gap: '2',
    bg: 'gamma.600',
    borderRadius: 'md',
    p: '2',
    my: '2',
    transition: '.3s ease-in-out',
    boxShadow: 'md',
    mx: ['0', null, '2'],
  },
  flexWrapperMysteryErrorView: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDir: 'row',
    w: 'full',
    gap: '2',
    my: '2',
    bg: 'gamma.600',
    borderRadius: 'md',
    p: '2',
    transition: '.3s ease-in-out',
    boxShadow: 'md',
  },
  flexWrapperMysteryTooltipIcon: {
    alignItems: 'center',
    justifyContent: 'center',
    bgGradient: 'linear-gradient(to-b, #FFE6B6, #AC8148)',
    boxShadow:
      '0px 2px 2px 0px rgba(0, 0, 0, 0.36), 0px 1px 0px 0px rgba(0, 0, 0, 0.44)',
    borderRadius: 'md',
    boxSize: '8',
    p: '2',
    color: 'white',
    cursor: 'pointer',
    fill: 'white',
  },
  tooltipIcon: {
    fill: 'gamma.600',
    boxShadow: 'none',
  },
  imageMysteryBet: {
    w: '5',
    transform: 'rotate(180deg)',
    cursor: 'pointer',
    mr: '4',
  },
  flexRaceInfo: {
    textTransform: 'uppercase',
    fontSize: 'xs',
    color: 'white',
    fontWeight: 'bold',
    gap: '1',
  },
  textPriceInfo: {
    textTransform: 'uppercase',
    fontSize: 'xs',
    color: 'beta.400',
    fontWeight: 'bold',
  },
  textRollover: {
    textTransform: 'uppercase',
    fontSize: 'xs',
    color: 'beta.400',
    fontWeight: 'bold',
  },
  textError: {
    color: 'white',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    fontSize: 'xs',
  },
  iconBack: {
    boxSize: '10',
    color: 'beta.500',
  },
  iconRace: { color: 'gamma.500' },
  textSpanWhite: {
    color: 'white',
  },
  buttonGroupAddToBetslip: {
    mr: '2',
    alignItems: 'center',
    maxW: ['250px', null, 'unset'],
  },
  buttonAddToBetslip: {
    variant: 'solid',
  },
  flexWrapperMysteryLabelView: {
    fontFamily: 'Roboto',
    fontWeight: 'extrabold',
  },
  buttonRollOver: {
    variant: 'solid',
    h: '8',
  },
};
